export const answersToFields = (answers) => {
  let i;
  var initialAnswers = {};

  for (i = 0; i < answers?.length; i++) {
    Object.keys(answers[i]).map((ele) => {
      if (
        ele != "questionType" &&
        ele != "questionNumber" &&
        ele != "answerDetails"
      ) {
        initialAnswers[
          answers[i]["questionType"] +
            "_" +
            answers[i]["questionNumber"] +
            "_" +
            ele
        ] = answers[i][ele];
      }

      if (ele === "answerDetails") {
        let j;
        if (
          answers[i] &&
          answers[i]["answerDetails"] &&
          answers[i]["answerDetails"].length == 1
        ) {
          Object.keys(answers[i]["answerDetails"][0]).map((element) => {
            if (element != "questionDetailNumber") {
              initialAnswers[
                answers[i]["questionType"] +
                  "-" +
                  answers[i]["questionNumber"] +
                  "-" +
                  element
              ] = answers[i]["answerDetails"][0][element];
            }
          });
        } else {
          for (j = 0; j < answers[i]["answerDetails"].length; j++) {
            let temp;

            if (
              answers[i] &&
              answers[i]["answerDetails"] &&
              answers[i]["answerDetails"][j] &&
              answers[i]["answerDetails"][j]["questionDetailNumber"]
            ) {
              temp =
                answers[i]["answerDetails"][j]["questionDetailNumber"].split(
                  ".",
                );

              Object.keys(answers[i]["answerDetails"][j]).map((element) => {
                if (element != "questionDetailNumber" && temp?.length > 0) {
                  initialAnswers[
                    answers[i]["questionType"] +
                      "-" +
                      answers[i]["questionNumber"] +
                      "-" +
                      element +
                      "-" +
                      temp[1]
                  ] = answers[i]["answerDetails"][j][element];
                }
              });
            }
          }
        }
      }
    });
  }

  return initialAnswers;
};

export const fieldsToAnswers = (values) => {
  var answersObj = {};
  var mqe;
  var fqe;
  var answersObjKey;
  Object.keys(values).map((ele) => {
    //mqe->main question element   fpe->followup question element
    mqe = ele.split("_");
    fqe = ele.split("-");
    if (
      (mqe[0] === "Primary" || mqe[0] === "Secondary" || mqe[0] === "Focus") &&
      Boolean(values[ele])
    ) {
      answersObjKey = mqe[0] + "_" + mqe[1];
      if (answersObj[answersObjKey]) {
        answersObj[answersObjKey][mqe[2]] = values[ele];
      } else {
        var obj = {};
        obj["questionType"] = mqe[0];
        obj["questionNumber"] = mqe[1];
        obj[mqe[2]] = values[ele];
        answersObj[answersObjKey] = obj;
      }
    }
  });
  Object.keys(values).map((ele) => {
    mqe = ele.split("_");
    fqe = ele.split("-");
    if (
      (fqe[0] === "Primary" || fqe[0] === "Secondary" || fqe[0] === "Focus") &&
      Boolean(values[ele])
    ) {
      answersObjKey = fqe[0] + "_" + fqe[1];
      if (fqe[3]) {
        if (answersObj[answersObjKey]) {
          if (answersObj[answersObjKey]["answerDetails"]) {
            var obj = {};
            obj["questionDetailNumber"] = fqe[1] + "." + fqe[3];
            obj[fqe[2]] = values[ele];
            answersObj[answersObjKey]["answerDetails"].push(obj);
          } else {
            answersObj[answersObjKey]["answerDetails"] = [];
            var obj = {};
            obj["questionDetailNumber"] = fqe[1] + "." + fqe[3];
            obj[fqe[2]] = values[ele];
            answersObj[answersObjKey]["answerDetails"].push(obj);
          }
        } else {
          answersObj[answersObjKey] = {
            questionType: fqe[0],
            questionNumber: fqe[1],
            answerDetails: [],
          };
          var obj = {};
          obj["questionDetailNumber"] = fqe[1] + "." + fqe[3];
          obj[fqe[2]] = values[ele];
          answersObj[answersObjKey]["answerDetails"].push(obj);
        }
      } else {
        if (answersObj[answersObjKey]) {
          if (answersObj[answersObjKey]["answerDetails"])
            answersObj[answersObjKey]["answerDetails"][0][fqe[2]] = values[ele];
          else {
            answersObj[answersObjKey]["answerDetails"] = [];
            var obj = {};
            obj["questionDetailNumber"] = fqe[1] + ".1";
            obj[fqe[2]] = values[ele];
            answersObj[answersObjKey]["answerDetails"].push(obj);
          }
        }
      }
    }
  });
  var answers = [];
  Object.keys(answersObj).map((ele) => {
    answers.push(answersObj[ele]);
  });
  return answers;
};

export const checkDuplicate = (values, dupFieldList) => {
  let duplicate = null;
  let flag = false;
  for (let i = 0; i < dupFieldList.length; i++) {
    let fieldValue = [];
    for (let j = 0; j < dupFieldList[i].length; j++) {
      let temp = values[dupFieldList[i][j]];
      if (Boolean(temp)) {
        if (Array.isArray(temp)) {
          fieldValue.push(temp);
        } else {
          temp = temp.split(";");
          fieldValue.push(temp);
        }
      }
    }

    for (let k = 0; k < fieldValue.length; k++) {
      for (let l = 0; l < fieldValue[k].length; l++) {
        for (let m = k + 1; m < fieldValue.length; m++) {
          if (fieldValue[m].includes(fieldValue[k][l])) {
            duplicate = i + 1;
            flag = true;
            break;
          }
        }
        if (flag) {
          break;
        }
      }
      if (flag) {
        break;
      }
    }
    if (flag) {
      break;
    }
  }
  return duplicate;
};
